<template>
  <div class="cookie">
    <img
      :src="currentCookieSrc"
      alt="Cookie Countdown"
      class="cookie-image"
      :class="{ shake: shouldShake }"
      ref="countdownCookie"
    />
    <div id="countdown">
      <div class="time" v-bind:class="{ expired: isExpired }">
        {{ minutes }}:{{ seconds }}
      </div>
    </div>

    <block-overlay :show="showBlockOverlay"></block-overlay>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import BlockOverlay from "@/components/BlockOverlay.vue";

export default {
  components: {
    BlockOverlay,
  },
  data() {
    return {
      timer: null,
      minutes: "00",
      seconds: "00",
      isExpired: false,
      totalSeconds: 0,
      oneFifthTime: 0,
      // remaining: 0,
      currentCookieSrc: require("@/assets/cookies/transparent_placeholder.svg"),
      // currentCookieSrc: "",
      lestSrc: "",
      shouldShake: false,
      showBlockOverlay: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    // user() {
    //   return this.$store.state.user;
    // },
  },
  watch: {
    user(newUser) {
      if (newUser && newUser.remaining) {
        this.totalSeconds = newUser.remaining;
        // this.oneFifthTime = newUser.limitSec / 5;
        this.updateMinutesAndSeconds();
      }
    },
    "user.remaining": function (remaining) {
      // console.log(JSON.stringify(this.user));
      sessionStorage.setItem("user", JSON.stringify(this.user));
      // console.log(newLimitSec)
      if (remaining <= 0) {
        this.showBlockOverlay = true;
      }
    },
  },
  methods: {
    ...mapMutations(["updateRemaining"]),
    updateMinutesAndSeconds() {
      const min = Math.floor(this.totalSeconds / 60);
      const sec = this.totalSeconds % 60;

      this.minutes = String(min).padStart(2, "0");
      this.seconds = String(sec).padStart(2, "0");

      this.oneFifthTime = this.user.limitSec / 5;

      // console.log(this.user.limitSec);
    },
    resetTimer() {
      clearInterval(this.timer);
      this.startTimer();
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.totalSeconds--;

        this.minutes = String(Math.floor(this.totalSeconds / 60)).padStart(
          2,
          "0"
        );
        this.seconds = String(this.totalSeconds % 60).padStart(2, "0");

        this.updateCookieImage();

        this.lestSrc = this.currentCookieSrc;

        if (this.totalSeconds <= 0) {
          clearInterval(this.timer);
          this.isExpired = true;
        } else {
          this.isExpired = false;
        }
        // this.updateLimitSec(this.totalSeconds);
        this.updateRemaining(this.totalSeconds);
      }, 1000);
    },
    updateCookieImage() {
      if (this.totalSeconds <= 0) {
        this.currentCookieSrc = require("@/assets/cookies/transparent_placeholder.svg");
      } else if (this.totalSeconds <= this.oneFifthTime) {
        this.currentCookieSrc = require("@/assets/cookies/cookies-05.svg");
        this.cookieShake(this.currentCookieSrc);
      } else if (this.totalSeconds <= this.oneFifthTime * 2) {
        this.currentCookieSrc = require("@/assets/cookies/cookies-04.svg");
        this.cookieShake(this.currentCookieSrc);
      } else if (this.totalSeconds <= this.oneFifthTime * 3) {
        this.currentCookieSrc = require("@/assets/cookies/cookies-03.svg");
        this.cookieShake(this.currentCookieSrc);
      } else if (this.totalSeconds <= this.oneFifthTime * 4) {
        this.currentCookieSrc = require("@/assets/cookies/cookies-02.svg");
        this.cookieShake(this.currentCookieSrc);
      } else {
        this.currentCookieSrc = require("@/assets/cookies/cookies-01.svg");
      }
    },
    cookieShake(src) {
      if (this.lestSrc != src) {
        this.shouldShake = true;
        setTimeout(() => (this.shouldShake = false), 100);
      }
    },
  },
  mounted() {
    if (this.user && this.user.remaining) {
      this.totalSeconds = this.user.remaining;
      this.updateMinutesAndSeconds();
      this.updateCookieImage();

      if (this.user.remaining <= 0) {
        this.showBlockOverlay = true;
      }
    }
    this.startTimer();
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>

<style>
.cookie {
  /* font-family: Arial, sans-serif;
  text-align: center;
  margin-top: 50px; */

  width: 70px;
  padding: 10px;
}

.cookie-image {
  width: 50px;
}

h1 {
  font-size: 24px;
}

/* #countdown .time {
  font-size: 48px;
  font-weight: bold;
  background-color: #f4f4f4;
  padding: 10px 20px;
  display: inline-block;
  margin: 20px 0;
  border-radius: 3px;
} */

#countdown .time {
  font-size: 1em;
  color: #0d2736;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  text-align: left;
  margin: 0;
  margin-top: 0;
  display: block;
  text-align: center;
}

#countdown .expired {
  background-color: #ff0000;
  color: #ffffff;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }

  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }

  20% {
    transform: translate(-2px, 0px) rotate(1deg);
  }

  30% {
    transform: translate(1px, 2px) rotate(0deg);
  }

  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }

  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }

  60% {
    transform: translate(-1px, 1px) rotate(0deg);
  }

  70% {
    transform: translate(1px, 1px) rotate(-1deg);
  }

  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }

  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }

  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

.shake {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
}
</style>
